module.exports = __webpack_public_path__ + "media/images/vp/parallax.02.1-535faee15d0dee808e6504e115341ff2.png";